/**
 * WEBSKY-7271
 * накосячили в настройках шлюза и стало приходить "frameUrl": "?session="
 * из-за этого отображалась форма поиска внутри фрейма
 */
export const isCorrectFrameUrl = (frameInfo) => {
    return !!(frameInfo === null || frameInfo === void 0 ? void 0 : frameInfo.frameUrl) && (frameInfo === null || frameInfo === void 0 ? void 0 : frameInfo.frameUrl) !== '?session=';
};
